import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
import BrandLogo from "./BrandLogo";

const LegalDocumentPage = ({ title, sections, testId }) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} | ShowMeLive`;
    return () => { document.title = previousTitle; };
  }, [title]);

  useEffect(() => {
    const sectionId = decodeURIComponent(window.location.hash.replace(/^#/, ""));
    if (!sectionId) return undefined;
    const frame = window.requestAnimationFrame(() => {
      document.getElementById(sectionId)?.scrollIntoView({ block: "start" });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [title]);

  return (
    <div className="min-h-screen bg-[#09090b] text-white" data-testid={testId}>
      <div
        className="pointer-events-none fixed inset-x-0 top-0 h-[32rem]"
        style={{ background: "radial-gradient(ellipse at top, rgba(37,99,235,.22), transparent 68%)" }}
      />

      <header className="relative border-b border-white/10 bg-black/45 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-4 sm:px-6">
          <Link to="/events" aria-label="ShowMeLive home">
            <BrandLogo />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm font-semibold text-gray-300 transition hover:bg-white/10 hover:text-white"
          >
            <ArrowLeft className="h-4 w-4" />
            Back
          </Link>
        </div>
      </header>

      <main className="relative mx-auto max-w-4xl px-4 py-12 sm:px-6 sm:py-16">
        <div className="mb-8 flex items-center gap-3 text-blue-300">
          <div className="flex h-10 w-10 items-center justify-center rounded-full border border-blue-400/25 bg-blue-500/10">
            <FileText className="h-5 w-5" />
          </div>
          <span className="text-xs font-bold uppercase tracking-[0.18em]">ShowMeLive Legal</span>
        </div>

        <article className="overflow-hidden rounded-3xl border border-white/10 bg-[#121216]/90 shadow-2xl shadow-black/40">
          <div className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10">
            <h1 className="text-3xl font-black tracking-tight text-white sm:text-4xl">{title}</h1>
          </div>

          <div className="space-y-9 px-6 py-8 sm:px-10 sm:py-10">
            {sections.map((section) => (
              <section key={section.heading} id={section.id} className="scroll-mt-24">
                <h2 className="mb-3 text-xl font-bold text-white">{section.heading}</h2>
                <div className="whitespace-pre-line text-[15px] leading-7 text-gray-300 sm:text-base">
                  {section.content}
                </div>
              </section>
            ))}
          </div>
        </article>

        <p className="mt-8 text-center text-xs text-gray-600">
          ShowMeLive is owned and operated by Emerging Technology LLC.
        </p>
      </main>
    </div>
  );
};

export default LegalDocumentPage;
